import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=dd10571e&scoped=true&"
import script from "./Typography.vue?vue&type=script&lang=js&"
export * from "./Typography.vue?vue&type=script&lang=js&"
import style0 from "./Typography.vue?vue&type=style&index=0&id=dd10571e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd10571e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dd10571e', component.options)
    } else {
      api.reload('dd10571e', component.options)
    }
    module.hot.accept("./Typography.vue?vue&type=template&id=dd10571e&scoped=true&", function () {
      api.rerender('dd10571e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Styles/Typography.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Typography.vue
// module id = ++KL
// module chunks = 0